"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusSelect = StatusSelect;

var _react = _interopRequireDefault(require("react"));

var _blocks = require("@bueno/blocks");

var _core = require("@lingui/core");

var _lists = require("../../../../components/Action/utils/lists");

var _utils = require("../../../../components/ActionModals/utils");

var _Trigger = require("./components/Trigger");

function StatusSelect({
  options,
  value,
  onChange
}) {
  const i18nStatusMap = (0, _lists.getStatusMap)(_core.i18n);
  return /*#__PURE__*/_react.default.createElement(_blocks.Menu, null, ({
    isOpen,
    toggle
  }) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Trigger.Trigger, {
    main: _core.i18n._({
      id: 'actions.v2.status_select.filter_status',
      message: 'Filter Status'
    }),
    sub: `${_core.i18n._({
      id: 'actions.v2.status_select.applied',
      message: 'Applied'
    })} (${value.size})`,
    onClick: toggle
  }), isOpen && /*#__PURE__*/_react.default.createElement(_blocks.Popover, {
    right: true
  }, /*#__PURE__*/_react.default.createElement(_blocks.ActionHeading, null, _core.i18n._({
    id: 'actions.v2.status_select.filter_status',
    message: 'Filter Status'
  })), /*#__PURE__*/_react.default.createElement(_blocks.ActionList, null, options.sort((a, b) => (0, _lists.getStatusOrder)(a) - (0, _lists.getStatusOrder)(b)).map(option => /*#__PURE__*/_react.default.createElement(_blocks.ActionItemCheckbox, {
    key: `StatusOption-${option}`,
    onChange: event => onChange(option, event.currentTarget.checked),
    isActive: value.has(option),
    checked: value.has(option)
  }, /*#__PURE__*/_react.default.createElement(_blocks.Chip, {
    size: "thin",
    type: "priority",
    appearance: "solid",
    priority: _utils.statusMap[option]
  }, i18nStatusMap[option])))))));
}